import React from 'react';
import { useIntl } from 'react-intl';
import type { SerializedPresaveSubscribeWidget } from 'fym-shared/src/smartlinks/types';
import { TypedMemo } from '../../../../common/types';
import { WidgetListItemProps } from '../props';
import { presaveSubscribeBlockDetail } from './presaveSubscribeServices';

/** The "Get every release" block in a list: "3 services and email". */
const PresaveSubscribeWidgetListItemComponent: React.FC<WidgetListItemProps<SerializedPresaveSubscribeWidget>> = ({
  widget,
}) => {
  const intl = useIntl();

  return (
    <div className="widget-list-item-text-container">
      <span className="text-1-line">{presaveSubscribeBlockDetail(intl, widget.data.services)}</span>
    </div>
  );
};

export const PresaveSubscribeWidgetListItem = TypedMemo(PresaveSubscribeWidgetListItemComponent);
